import { VStack, Text, Button, Box } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { AiSubscriptionActionType, AiSubscriptionProduct, AiTierLevel } from 'types/AiSubscription';

type Props = {
  product: AiSubscriptionProduct;
  onSelectPlan: (tierId: string) => void;
  pendingChangeDetails?: string;
  disabled?: boolean;
};

const getButtonText = (variant: AiSubscriptionActionType): string => {
  if (variant === AiSubscriptionActionType.CURRENT) return 'Aktuell';
  if (variant === AiSubscriptionActionType.UPGRADE) return 'Upgrade';
  if (variant === AiSubscriptionActionType.DOWNGRADE) return 'Downgrade';
  return '';
};

const getTokenAmount = (product: AiSubscriptionProduct): string => {
  const isUnlimited = product.tier === AiTierLevel.UNLIMITED;
  if (isUnlimited) {
    return '∞';
  }
  return `${product.monthlyTokens}`;
};

export const AiProduct = ({
  product,
  onSelectPlan,
  pendingChangeDetails,
  disabled,
}: Props): ReactElement => {
  return (
    <VStack
      gap="18px"
      p="15px"
      borderRadius="10px"
      border="default"
      borderColor="border.accent"
      alignItems="flex-start"
      flex={1}
      alignSelf="stretch"
    >
      <VStack gap="0" alignItems="flex-start">
        <Text textStyle="body.s.medium">{product.name}</Text>
        <Text textStyle="body.s.regular" color="text.secondary">
          {getTokenAmount(product)} KI-Arbeitsblätter
        </Text>
      </VStack>
      <VStack alignItems="flex-start">
        <Text textStyle="h3.medium">{product.priceInEuro} €</Text>
        <Text textStyle="body.xs.regular" color="text.quaternary">
          {product.description}
        </Text>
      </VStack>
      <Box display="flex" flexGrow={1} alignItems="flex-end">
        <Button variant="primary" disabled={disabled} onClick={() => onSelectPlan(product.id)}>
          {getButtonText(product.actionType)}
        </Button>
      </Box>
      {pendingChangeDetails && (
        <Text textStyle="body.xs.regular" color="text.quaternary">
          {pendingChangeDetails}
        </Text>
      )}
    </VStack>
  );
};
